import React from 'react';
import type { VisibaCortexHeadLessStackProps } from './headless_stack.component';
import { HeadLessStack } from './headless_stack.component';
import { unwrapFragment } from './unwrap_fragment';

export interface VisibaCortexHStackProps extends Partial<Omit<VisibaCortexHeadLessStackProps, 'axis'>> {
	className?: string;
}

/**
 * # cortex:react-ui:HStack
 * Deprecated: Use Cellula components instead
 */
export const HStack: React.FC<VisibaCortexHStackProps> = ({ className, spacing = 0, fluid = true, children }) => {
	const flatten = unwrapFragment(children);

	return (
		<HeadLessStack spacing={spacing} axis={'Horizontal'} fluid={fluid}>
			{({ childClassName, parentClassName }) => (
				<div className={`${className ?? ''} ${parentClassName}`.trim()}>
					{flatten.map((child) => {
						if (child === null) return child;

						return React.cloneElement(child, {
							...child.props,
							className: `${child.props.className ?? ''} ${childClassName}`.trim(),
						});
					})}
				</div>
			)}
		</HeadLessStack>
	);
};
